/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
/*///////////////////////////////////////////////////////////*/
/*///////////////////////////////////////////////////////////*/
/*///////////////////////////////////////////////////////////*/
/*///////////////////////////////////////////////////////////*/
/*///////////////////////////////////////////////////////////*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h4: "h4",
    p: "p",
    img: "img",
    h3: "h3",
    h2: "h2"
  }, _provideComponents(), props.components), {WidgetRightElement, ContactForm, FeatureList, WidgetLeftPicture, Button, WidgetRightPicture, WidgetCenterText} = _components;
  if (!Button) _missingMdxReference("Button", true);
  if (!ContactForm) _missingMdxReference("ContactForm", true);
  if (!FeatureList) _missingMdxReference("FeatureList", true);
  if (!WidgetCenterText) _missingMdxReference("WidgetCenterText", true);
  if (!WidgetLeftPicture) _missingMdxReference("WidgetLeftPicture", true);
  if (!WidgetRightElement) _missingMdxReference("WidgetRightElement", true);
  if (!WidgetRightPicture) _missingMdxReference("WidgetRightPicture", true);
  return React.createElement(React.Fragment, null, React.createElement(WidgetRightElement, {
    gap: 100,
    topSpace: 40
  }, React.createElement("div", null, React.createElement(ContactForm, {
    advToken: "GBoRCKbUwZgCEOqN47MB",
    pageName: "Customer feedback contact",
    twoColumn: true
  })), React.createElement(_components.h1, null, "PressnXPress Customer Satisfaction Management"), React.createElement(_components.h4, null, "Optimize customer experience to drive loyalty and growth"), React.createElement(_components.p, null, "Press'nXPress platform provides the tools you need to discover insights from every customer interaction and conversation."), React.createElement(_components.p, null, "With Press'nXPress, your team can improve customer experience, increase customer retention, drive brand loyalty and revenue growth:"), React.createElement(FeatureList, null, React.createElement(_components.p, null, "Press'nXPress empowers you to gather real-time data and feedback from your customers, significantly enhancing their experience.\nThis platform serves as an invaluable tool for improving customer satisfaction and loyalty."), React.createElement(_components.p, null, "One of the compelling aspects of the Press'nXPress solution is its versatility. You can pose various questions to customers across different channels\nand touchpoints, ensuring that you don't repeat the same question in the same context."), React.createElement(_components.p, null, "Press'nXPress provides an overarching view of your organization's performance from a customer perspective. It enables you to stay connectedwith your customers\nconsistently throughout the year, rather than relying on sporadic interactions. This continuous feedback loop contributes to an enhanced customer experience."))), "\n", "\n", React.createElement(WidgetLeftPicture, {
    topSpace: 150,
    gap: 70,
    backgroundType: "circle"
  }, React.createElement(_components.img, {
    src: "/0b8f2783e6d3e3ef6f3dd892b8db81c1/pressnxpress-touchless-feedback-kiosk.webp",
    alt: "focus on your biggest opportunities"
  }), React.createElement(_components.h3, null, "Collect Feedback From Every Interaction Point"), React.createElement(_components.p, null, "Go beyond the traditional direct feedback methods, such as surveys and chat logs,\nby incorporating in-the-moment micro-feedback and indirect data sources,\nsuch as social reviews and mentions—ensuring you’re no longer forced\nto make business decisions based on a fraction of available customer data."), React.createElement(Button, {
    link: "/collector",
    fill: true
  }, "Learn More")), "\n", "\n", React.createElement(WidgetRightPicture, {
    topSpace: 200,
    gap: 70,
    backgroundType: "circle",
    reverseResponsive: true
  }, React.createElement(_components.img, {
    src: "/eb44a850633aef82b055033a67f41efc/pressnxpress-feedback-management-dashboard.webp",
    alt: "real time and actionable insights"
  }), React.createElement(_components.h3, null, "Learn How Your Customers Feel About Your Brand Across Touchpoints"), React.createElement(_components.p, null, "Our real-time pre-built dashboard empowers your teams across organization to quickly analyze\nthe results and make the right decisions to take action and improve."), React.createElement(Button, {
    link: "/insight",
    fill: true
  }, "Learn More")), "\n", "\n", React.createElement(WidgetCenterText, {
    topSpace: 150,
    width: 790,
    topSpaceResponsive: 150
  }, React.createElement(_components.h2, null, "Listen to Your Customers"), React.createElement(_components.p, null, "Enable your customers to tell you what is most important for them, in the way they want as they interact with your brand"), React.createElement(_components.p, null, "With Press'nXPress feedback collectors and analytics platform, equip your entire organization\nwith powerful insights from feedback collected at physical interaction points, website, email,\nphone call, social reviews, and chats across customer journeys.")), "\n", "\n", React.createElement(WidgetLeftPicture, {
    topSpace: 120,
    gap: 70,
    backgroundType: "circle",
    style: {
      marginBottom: "150px"
    }
  }, React.createElement(_components.img, {
    src: "/04649b4b09883b0cabfb9772da5a9a02/pressnxpress-contact-hub.webp",
    alt: "recover dissatisfied customers at scale"
  }), React.createElement(_components.h3, null, "Immediate Improvement Action"), React.createElement(_components.p, null, "Empower the CX team and frontline employees with accurate and to the point recommendations,\nso they know precisely how, where, and when to act."), React.createElement(Button, {
    link: "/products/dashboard",
    fill: true
  }, "Learn More")), "\n", "\n", React.createElement(_components.h1, null, "Get started with Press'nXPress today"), "\n", React.createElement(Button, {
    link: "#pressnxpress-customer-satisfaction-management",
    fill: true,
    style: {
      marginBottom: "36px"
    }
  }, "Request Demo"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
